
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc-trichy",
      function () {
        return require("private-next-pages/tnpsc-trichy/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc-trichy"])
      });
    }
  